import React from "react";
import Types from "prop-types";
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { getDashboardOptions } from "../../../config/dashboardOptions";

class DashboardSelectionPage extends React.Component {

  handleDashboardSelect(dashboard) {
    window.location.href = dashboard.url;
  }

  render() {
    const { t } = this.props;
    const dashboardOptions = getDashboardOptions();

    return (
      <form>
        <Helmet>
          <title>Select Dashboard | Careem</title>
        </Helmet>

        <h1>{t("dashboard_selection:title", "Select Dashboard")}</h1>
        
        <h3 style={{ textAlign: "center", marginBottom: "30px" }}>
          {t("dashboard_selection:description", "Please select the dashboard you want to access to continue with the login process.")}
        </h3>

        <div className="dashboard-selection-container">
          {dashboardOptions.map((dashboard) => (
              <div 
              key={dashboard.id}
              className="dashboard-option"
              onClick={() => this.handleDashboardSelect(dashboard)}
              style={{
                border: "1px solid var(--border-primary)",
                borderRadius: "4px",
                padding: "20px",
                marginBottom: "15px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                backgroundColor: "var(--background-primary)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "var(--border-state-hover)";
                e.currentTarget.style.backgroundColor = "var(--background-secondary)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--border-primary)";
                e.currentTarget.style.backgroundColor = "var(--background-primary)";
              }}
            >
              <div style={{ 
                fontWeight: "600", 
                fontSize: "18px", 
                marginBottom: "8px",
                color: "var(--text-primary)",
                fontFamily: "CircularStd-Medium, sans-serif"
              }}>
                {dashboard.name}
              </div>
              <div style={{ 
                fontSize: "14px", 
                color: "var(--text-secondary)",
                lineHeight: "1.4"
              }}>
                {dashboard.description}
              </div>
            </div>
            ))}
        </div>

        <div style={{ 
          marginTop: "30px", 
          padding: "15px", 
          backgroundColor: "var(--background-state-warning-mid-emphasize)", 
          border: "1px solid var(--border-state-warning-high-emphasize)",
          borderRadius: "4px",
          fontSize: "14px",
          color: "var(--text-state-warning)",
          textAlign: "center"
        }}>
          <strong>Note:</strong> You are seeing this page because no specific dashboard was specified in your login URL. Please select the appropriate dashboard to continue.
        </div>
      </form>
    );
  }
}

DashboardSelectionPage.propTypes = {
  t: Types.func.isRequired,
};

export default withTranslation()(DashboardSelectionPage);